<div id="loginPage" >

  <div id="welcome">
    <p i18n="Welcome note@@loginPageWelcome">Witaj w systemie:</p>
    <img id="logoId" src="/assets/logo.png">
    <p id="warning">{{warningMessage}}</p>
    <div id="loginLine">
      <img id="loginIco"src="/assets/user.png" alt="Search">
      <input type="text" (focusout)='userFocusOut($event.target)' [(ngModel)]="user" (focus)='userFocus($event.target)' (keypress)='userChanged($event.target)'>
    </div>
    <div id="loginLine">
      <img id="loginIco"src="/assets/key.png" alt="Search">
      <input type="password" (focusout)='passFocusOut($event.target)'  [(ngModel)]="pass" (focus)='passFocus($event.target)' (keypress)='passChanged($event.target)'>
    </div>
    <label class="container">
      <p i18n="Remember checkbox in logging page@@loginPageRemember">Zapamiętaj</p>
      <input type="checkbox"  [(ngModel)]="rememberCred">
      <span class="checkmark"></span>
    </label>
    <button (click)="clickLogin()" i18n="Text in login button@@loginPageLogin">LOGOWANIE</button>
  </div>
</div>

